import {LabelRegular, TextMedium} from '@hm/fundamental'
import {CircularProgress} from '@material-ui/core'
import {AxiosError} from 'axios'
import React from 'react'

import {usePayer} from '../../hooks/usePayer'
import {useTranslation} from '../../hooks/useTranslation'

type RolePayerLookupChipProps = {
  payerId: string
  error?: Error
}

export const RolePayerLookupChip = ({payerId}: RolePayerLookupChipProps) => {
  const {t} = useTranslation()

  const payerQueryInfo = usePayer({payerId})
  const payer = payerQueryInfo.data

  if (payerQueryInfo.isLoading) {
    return <CircularProgress size="20" />
  }

  if (payerQueryInfo.isError) {
    return (
      <div className="flex flex-col items-start">
        <TextMedium className="text-foreground">{payerId}</TextMedium>
        <TextMedium className="text-foreground">Error: Could not load payer</TextMedium>
        <TextMedium className="text-foreground">
          {(payerQueryInfo.error as AxiosError).message}
        </TextMedium>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-start">
      <LabelRegular className="text-foreground_faded">{t('manageUser.payer')}</LabelRegular>
      <TextMedium className="text-foreground">{payer?.payerName}</TextMedium>
      <LabelRegular className="text-foreground_faded">{payer?.payerNumber}</LabelRegular>
    </div>
  )
}
